import request from "superagent";
import Promise from "promise";
export const post = (values, targetUrl) => {
	return new Promise((resolve, reject) => {
		request
			.post(targetUrl)
			.send(values)
			.end((error, response) => {
				if (response.ok) {
					resolve(response.body);
				} else {
					reject("Error");
				}
			});
	});
};
export const get = (targetUrl) => {
	return new Promise((resolve, reject) => {
		request.get(targetUrl).end((error, response) => {
			if (response.ok) {
				resolve(response.body);
			} else {
				reject("Error");
			}
		});
	});
};
